const Layout = () => import('@/components/layout/saas_layout')
const Take = () => import('@/views/pileaccount/saas_take.vue')
const Pileaccount = () => import('@/views/pileaccount/saas_pileaccount.vue')

const ConsmRecords = () => import('@/views/pileaccount/saas_consmrecords.vue')
const routes = {
  path: '/pileaccount',
  name: 'pileaccount',
  meta: {
    title: '桩主管理',
    requireAuth:true
  },
  component: Layout,
  children: [
    {
      path: 'pilaccount',
      name: 'pilaccount',
      meta: {
        title: '桩主提现账户',
        requireAuth:true
      },
      component: Pileaccount
    },
    {
      path: 'take',
      name: 'take',
      meta: {
        title: '桩主收入记录',
        requireAuth:true
      },
      component: Take
    },
    {
      path: 'consmrecords',
      name: 'consmrecords',
      meta: {
        title: '桩主提现记录',
        requireAuth:true
      },
      component: ConsmRecords
    }
  ]
}

export default routes